import { render, staticRenderFns } from "./PhoneWebGetTheAppBanner.vue?vue&type=template&id=225bb79b&scoped=true"
import script from "./PhoneWebGetTheAppBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneWebGetTheAppBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneWebGetTheAppBanner.vue?vue&type=style&index=0&id=225bb79b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bb79b",
  null
  
)

export default component.exports